import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFeatureToggles = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 22,
	height: 12,
	fill: "none",
	viewBox: "0 0 22 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M6 12c-1.667 0-3.083-.583-4.25-1.75C.583 9.083 0 7.667 0 6c0-1.667.583-3.083 1.75-4.25C2.917.583 4.333 0 6 0h10c1.667 0 3.083.583 4.25 1.75C21.417 2.917 22 4.333 22 6c0 1.667-.583 3.083-1.75 4.25C19.083 11.417 17.667 12 16 12H6Zm0-2h10c1.1 0 2.042-.392 2.825-1.175C19.608 8.042 20 7.1 20 6s-.392-2.042-1.175-2.825C18.042 2.392 17.1 2 16 2H6c-1.1 0-2.042.392-2.825 1.175C2.392 3.958 2 4.9 2 6s.392 2.042 1.175 2.825C3.958 9.608 4.9 10 6 10Zm10-1c.833 0 1.542-.292 2.125-.875A2.893 2.893 0 0 0 19 6c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 16 3c-.833 0-1.542.292-2.125.875A2.893 2.893 0 0 0 13 6c0 .833.292 1.542.875 2.125A2.893 2.893 0 0 0 16 9Z" })
});
export { SvgFeatureToggles as ReactComponent };
